import React, { Component } from "react";
import DetailsModalRecurring from "../modals/DetailsModalRecurring";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

class RecurringTripRow extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalVisible:false,
            page:this.props.page,
        }
    }

    toggleModal(){
        this.setState({modalVisible: !this.state.modalVisible})
    }

    updateOnClose(tripId){
        this.props.updateItins(tripId)
        this.toggleModal()
    }

    render(){
        return(
            <tr id={this.props.currentItins.id}>
                <td>
                <ul>
                        <li>{this.props.currentItins.day}</li>
                    </ul>
                </td>
                <td>
                    <ul>
                        <li>{`${this.props.currentItins.pickup.city}, ${this.props.currentItins.pickup.state}`}</li>
                        <li>{`${this.props.currentItins.dropoff.city}, ${this.props.currentItins.dropoff.state}`}</li>
                    </ul>
                </td>
                {this.props.abbreviateColumns === false && 
                    <td>
                        <ul>
                            <li>{this.props.currentItins.ptime !== null ? this.props.currentItins.ptime.substring(0,5) : "None"}</li>
                            <li>{this.props.currentItins.dtime !== null ? this.props.currentItins.dtime.substring(0,5) : "None"}</li>
                        </ul>
                    </td>
                }
                {this.props.abbreviateColumns === false && 
                    <td> {this.props.currentItins.leg === "RETURN" ? "RETURN" : "TAKE"} </td>
                    }
                {this.props.abbreviateColumns === false && 
                    <td>{this.props.currentItins.status.toUpperCase()}</td>
                }
                <td className={"openPT1"}>
                    {this.props.currentItins.pt1 !== null 
                    ? <button onClick={(e) => this.props.openPT1(this.props.currentItins.pt1)}>VIEW <OpenInNewIcon/></button>
                    : "NONE"}                    
                </td>
                <td>
                {this.state.modalVisible && 
                    <DetailsModalRecurring 
                        details={this.props.currentItins} 
                        toggle={this.state.modalVisible}
                        id={this.props.currentItins.id}
                        page={this.state.page}
                        handleClick={this.updateOnClose.bind(this)}/>}
                    <button onClick={(e) => this.toggleModal()}>i</button>
                </td>
            </tr>
            )
    }
}

export default RecurringTripRow